import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-component-o-auth',
  templateUrl: './component-o-auth.component.html',
  styleUrls: ['./component-o-auth.component.css']
})
export class ComponentOAuthComponent implements OnInit {

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _authentication: AuthenticationService,
    private _formBuilder: FormBuilder
  ) { }
  
  public form: FormGroup;
  public year = new Date().getFullYear();
  public title: string;
  public organizationName: string;
  public authResult: any;
  public isLoading = false;
  public error: string = null;
  public showSuccessMessage = false;
  public notSuccessMessage = true;
  public companyId: string;
  public background1 = false;
  public background2 = true;


  ngOnInit() {
    this.organizationName = environment.organization;
    this.form = this._formBuilder.group({});
    const authResult = sessionStorage.getItem('authResult');
    if (authResult) {
      this.authResult = JSON.parse(authResult);
    } else {
      console.log("No token available!");
      this._router.navigate(['/login']);
    }

    // Get companyId from route parameters
    // this._route.params.subscribe(params => {
    //   this.companyId = params['companyId'];
    //   const boydPattern = /^boyd\d+$/;
    //   if(boydPattern.test(this.companyId)){
    //     this.background2 = true;
    //   }else {
    //     this.background2 = true;
    //   }
    //   console.log('Company ID:', this.companyId);
    // });
  }

  allowtoclient(): void {
    if (!this.authResult) {
      return;
    }
    this.isLoading = true;
    this._authentication.o_auths(this.authResult.token, "True")
      .pipe(
        tap(() => {
          this.showSuccessMessage = true;
          this.notSuccessMessage = false;
          sessionStorage.removeItem('authResult');
        }),
        catchError((error) => {
          this.error = error.message;
          this.isLoading = false;
          return throwError(error);
        })
      )
      .subscribe(() => {
        sessionStorage.removeItem('authResult')
        const redirect = sessionStorage.getItem('redirect')
        window.location.href = redirect;
      });
  }
  
  denytoclient():void {
    sessionStorage.removeItem('authResult')
    const redirect = sessionStorage.getItem('redirect')
    window.location.href = redirect;
  }
}
